// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3hsbP","footer":"ModalUpdate_footer__3jWr_"};